export const getColorEmoji = (energyColor: string) => {
	if (energyColor === 'y') {
		return '🟨';
	} else if (energyColor === 'b') {
		return '🟦';
	} else if (energyColor === 'r') {
		return '🟥';
	} else if (energyColor === 'g') {
		return '🟩';
	} else {
		return '⬛';
	}
};

export function getColor(color: string) {
	if (color === 'yellow') {
		return '#f6de9a';
	} else if (color === 'blue') {
		return '#15bedb';
	} else if (color === 'red') {
		return '#efa1ae';
	} else if (color === 'green') {
		return '#556341';
	} else if (color === 'fail') {
		return '#fb2d01';
	}

	return 'white';
}
